(function () {
  const offsetStyles = {
    bold: { label: 'Bold', A: 0x1d400, a: 0x1d41a, '0': 0x1d7ce },
    italic: { label: 'Italic', A: 0x1d434, a: 0x1d44e, exceptions: { h: 0x210e } },
    boldItalic: { label: 'Bold Italic', A: 0x1d468, a: 0x1d482 },
    sans: { label: 'Sans-Serif', A: 0x1d5a0, a: 0x1d5ba, '0': 0x1d7e2 },
    sansBold: { label: 'Sans Bold', A: 0x1d5d4, a: 0x1d5ee, '0': 0x1d7ec },
    sansItalic: { label: 'Sans Italic', A: 0x1d608, a: 0x1d622 },
    sansBoldItalic: { label: 'Sans Bold Italic', A: 0x1d63c, a: 0x1d656 },
    monospace: { label: 'Monospace', A: 0x1d670, a: 0x1d68a, '0': 0x1d7f6 },
    script: {
      label: 'Script',
      A: 0x1d49c,
      a: 0x1d4b6,
      exceptions: {
        B: 0x212c, E: 0x2130, F: 0x2131, H: 0x210b, I: 0x2110, L: 0x2112,
        M: 0x2133, R: 0x211b, e: 0x212f, g: 0x210a, o: 0x2134
      }
    },
    boldScript: { label: 'Bold Script', A: 0x1d4d0, a: 0x1d4ea },
    fraktur: {
      label: 'Fraktur',
      A: 0x1d504,
      a: 0x1d51e,
      exceptions: { C: 0x212d, H: 0x210c, I: 0x2111, R: 0x211c, Z: 0x2128 }
    },
    boldFraktur: { label: 'Bold Fraktur', A: 0x1d56c, a: 0x1d586 },
    doubleStruck: {
      label: 'Double-Struck',
      A: 0x1d538,
      a: 0x1d552,
      '0': 0x1d7d8,
      exceptions: {
        C: 0x2102, H: 0x210d, N: 0x2115, P: 0x2119,
        Q: 0x211a, R: 0x211d, Z: 0x2124
      }
    },
    wide: { label: 'Wide', A: 0xff21, a: 0xff41, '0': 0xff10 },
    bubble: {
      label: 'Bubble',
      A: 0x24b6,
      a: 0x24d0,
      digits: {
        '0': 0x24ea, '1': 0x2460, '2': 0x2461, '3': 0x2462, '4': 0x2463,
        '5': 0x2464, '6': 0x2465, '7': 0x2466, '8': 0x2467, '9': 0x2468
      }
    },
    bubbleBlack: {
      label: 'Bubble Black',
      A: 0x1f150,
      a: 0x1f150,
      digits: {
        '0': 0x24ff, '1': 0x2776, '2': 0x2777, '3': 0x2778, '4': 0x2779,
        '5': 0x277a, '6': 0x277b, '7': 0x277c, '8': 0x277d, '9': 0x277e
      }
    },
    square: { label: 'Square', A: 0x1f130, a: 0x1f130 },
    squareBlack: { label: 'Square Black', A: 0x1f170, a: 0x1f170 }
  };

  const tinyMap = {
    a: 'ᴀ', b: 'ʙ', c: 'ᴄ', d: 'ᴅ', e: 'ᴇ', f: 'ꜰ', g: 'ɢ', h: 'ʜ', i: 'ɪ',
    j: 'ᴊ', k: 'ᴋ', l: 'ʟ', m: 'ᴍ', n: 'ɴ', o: 'ᴏ', p: 'ᴘ', q: 'ǫ', r: 'ʀ',
    s: 'ѕ', t: 'ᴛ', u: 'ᴜ', v: 'ᴠ', w: 'ᴡ', x: 'x', y: 'ʏ', z: 'ᴢ'
  };

  const upsideDownMap = {
    a: 'ɐ', b: 'q', c: 'ɔ', d: 'p', e: 'ǝ', f: 'ɟ', g: 'ƃ', h: 'ɥ', i: 'ᴉ',
    j: 'ɾ', k: 'ʞ', l: 'l', m: 'ɯ', n: 'u', o: 'o', p: 'd', q: 'b', r: 'ɹ',
    s: 's', t: 'ʇ', u: 'n', v: 'ʌ', w: 'ʍ', x: 'x', y: 'ʎ', z: 'z',
    A: '∀', B: '𐐒', C: 'Ɔ', D: 'p', E: 'Ǝ', F: 'Ⅎ', G: 'פ', H: 'H', I: 'I',
    J: 'ſ', K: 'ʞ', L: '˥', M: 'W', N: 'N', O: 'O', P: 'Ԁ', Q: 'Q', R: 'ᴿ',
    S: 'S', T: '⊥', U: '∩', V: 'Λ', W: 'M', X: 'X', Y: '⅄', Z: 'Z',
    '0': '0', '1': 'Ɩ', '2': 'ᄅ', '3': 'Ɛ', '4': 'ㄣ', '5': 'ϛ',
    '6': '9', '7': 'ㄥ', '8': '8', '9': '6',
    '.': '˙', ',': "'", '?': '¿', '!': '¡', '"': ',,', "'": ',',
    '(': ')', ')': '(', '[': ']', ']': '[', '{': '}', '}': '{',
    '<': '>', '>': '<', '&': '⅋', '_': '‾'
  };

  const mirrorMap = {
    a: 'ɒ', b: 'd', c: 'ↄ', d: 'b', e: 'ɘ', f: 'ʇ', g: 'ǫ', h: 'ʜ', i: 'i',
    j: 'ⱼ', k: 'ʞ', l: 'l', m: 'm', n: 'ᴎ', o: 'o', p: 'q', q: 'p', r: 'ɿ',
    s: 'ƨ', t: 'ƚ', u: 'u', v: 'v', w: 'w', x: 'x', y: 'y', z: 'z',
    A: 'A', B: 'ᙠ', C: 'Ↄ', D: 'ᗡ', E: 'Ǝ', F: 'ꟻ', G: 'Ꭾ', H: 'H', I: 'I',
    J: 'Ⴑ', K: 'ʞ', L: '⅃', M: 'M', N: 'ᴎ', O: 'O', P: 'ꟼ', Q: 'Ọ', R: 'Я',
    S: 'Ƨ', T: 'T', U: 'U', V: 'V', W: 'W', X: 'X', Y: 'Y', Z: 'Z'
  };

  const supMap = {
    a: 'ᵃ', b: 'ᵇ', c: 'ᶜ', d: 'ᵈ', e: 'ᵉ', f: 'ᶠ', g: 'ᵍ', h: 'ʰ', i: 'ⁱ',
    j: 'ʲ', k: 'ᵏ', l: 'ˡ', m: 'ᵐ', n: 'ⁿ', o: 'ᵒ', p: 'ᵖ', q: 'q', r: 'ʳ',
    s: 'ˢ', t: 'ᵗ', u: 'ᵘ', v: 'ᵛ', w: 'ʷ', x: 'ˣ', y: 'ʸ', z: 'ᶻ',
    A: 'ᴬ', B: 'ᴮ', C: 'ᶜ', D: 'ᴰ', E: 'ᴱ', F: 'ᶠ', G: 'ᴳ', H: 'ᴴ', I: 'ᴵ',
    J: 'ᴶ', K: 'ᴷ', L: 'ᴸ', M: 'ᴹ', N: 'ᴺ', O: 'ᴼ', P: 'ᴾ', Q: 'Q', R: 'ᴿ',
    S: 'ˢ', T: 'ᵀ', U: 'ᵁ', V: 'ⱽ', W: 'ᵂ', X: 'ˣ', Y: 'ʸ', Z: 'ᶻ',
    '0': '⁰', '1': '¹', '2': '²', '3': '³', '4': '⁴', '5': '⁵',
    '6': '⁶', '7': '⁷', '8': '⁸', '9': '⁹',
    '+': '⁺', '-': '⁻', '=': '⁼', '(': '⁽', ')': '⁾'
  };

  const subMap = {
    a: 'ₐ', e: 'ₑ', h: 'ₕ', i: 'ᵢ', j: 'ⱼ', k: 'ₖ', l: 'ₗ', m: 'ₘ', n: 'ₙ',
    o: 'ₒ', p: 'ₚ', r: 'ᵣ', s: 'ₛ', t: 'ₜ', u: 'ᵤ', v: 'ᵥ', x: 'ₓ',
    '0': '₀', '1': '₁', '2': '₂', '3': '₃', '4': '₄', '5': '₅',
    '6': '₆', '7': '₇', '8': '₈', '9': '₉',
    '+': '₊', '-': '₋', '=': '₌', '(': '₍', ')': '₎'
  };

  const COMBINING_TILDE = 0x0334;
  const COMBINING_STRIKE = 0x0336;
  const COMBINING_LOW_LINE = 0x0332;

  function transformOffset(text, key) {
    const cfg = offsetStyles[key];
    let out = '';
    for (const ch of text) {
      if (cfg.exceptions && cfg.exceptions[ch] != null) {
        out += String.fromCodePoint(cfg.exceptions[ch]);
        continue;
      }
      const code = ch.charCodeAt(0);
      if (ch >= 'A' && ch <= 'Z' && cfg.A != null) {
        out += String.fromCodePoint(cfg.A + (code - 65));
      } else if (ch >= 'a' && ch <= 'z') {
        if (cfg.a != null) {
          out += String.fromCodePoint(cfg.a + (code - 97));
        } else if (cfg.A != null) {
          out += String.fromCodePoint(cfg.A + (code - 97));
        } else {
          out += ch;
        }
      } else if (ch >= '0' && ch <= '9') {
        if (cfg.digits && cfg.digits[ch] != null) {
          out += String.fromCodePoint(cfg.digits[ch]);
        } else if (cfg['0'] != null) {
          out += String.fromCodePoint(cfg['0'] + (code - 48));
        } else {
          out += ch;
        }
      } else {
        out += ch;
      }
    }
    return out;
  }

  function transformMap(text, map, opts) {
    const reverse = !!(opts && opts.reverse);
    const chars = [];
    for (const ch of text) {
      chars.push(map[ch] != null ? map[ch] : ch);
    }
    return reverse ? chars.reverse().join('') : chars.join('');
  }

  function decorate(text, codePoint) {
    let out = '';
    const mark = String.fromCodePoint(codePoint);
    for (const ch of text) {
      out += ch;
      if (ch !== ' ' && ch !== '\n' && ch !== '\t') {
        out += mark;
      }
    }
    return out;
  }

  const styles = [
    { key: 'bold', label: 'Bold', transform: (t) => transformOffset(t, 'bold') },
    { key: 'italic', label: 'Italic', transform: (t) => transformOffset(t, 'italic') },
    { key: 'boldItalic', label: 'Bold Italic', transform: (t) => transformOffset(t, 'boldItalic') },
    { key: 'sans', label: 'Sans-Serif', transform: (t) => transformOffset(t, 'sans') },
    { key: 'sansBold', label: 'Sans Bold', transform: (t) => transformOffset(t, 'sansBold') },
    { key: 'sansItalic', label: 'Sans Italic', transform: (t) => transformOffset(t, 'sansItalic') },
    { key: 'sansBoldItalic', label: 'Sans Bold Italic', transform: (t) => transformOffset(t, 'sansBoldItalic') },
    { key: 'monospace', label: 'Monospace', transform: (t) => transformOffset(t, 'monospace') },
    { key: 'script', label: 'Script', transform: (t) => transformOffset(t, 'script') },
    { key: 'boldScript', label: 'Bold Script', transform: (t) => transformOffset(t, 'boldScript') },
    { key: 'fraktur', label: 'Fraktur', transform: (t) => transformOffset(t, 'fraktur') },
    { key: 'boldFraktur', label: 'Bold Fraktur', transform: (t) => transformOffset(t, 'boldFraktur') },
    { key: 'doubleStruck', label: 'Double-Struck', transform: (t) => transformOffset(t, 'doubleStruck') },
    { key: 'wide', label: 'Wide', transform: (t) => transformOffset(t, 'wide') },
    { key: 'bubble', label: 'Bubble', transform: (t) => transformOffset(t, 'bubble') },
    { key: 'bubbleBlack', label: 'Bubble Black', transform: (t) => transformOffset(t.toUpperCase(), 'bubbleBlack') },
    { key: 'square', label: 'Square', transform: (t) => transformOffset(t.toUpperCase(), 'square') },
    { key: 'squareBlack', label: 'Square Black', transform: (t) => transformOffset(t.toUpperCase(), 'squareBlack') },
    { key: 'tiny', label: 'Tiny', transform: (t) => transformMap(t.toLowerCase(), tinyMap) },
    { key: 'sup', label: 'Superscript', transform: (t) => transformMap(t, supMap) },
    { key: 'sub', label: 'Subscript', transform: (t) => transformMap(t, subMap) },
    { key: 'upsideDown', label: 'Upside Down', transform: (t) => transformMap(t, upsideDownMap, { reverse: true }) },
    { key: 'mirror', label: 'Mirror', transform: (t) => transformMap(t, mirrorMap, { reverse: true }) },
    { key: 'underline', label: 'Underline', transform: (t) => decorate(t, COMBINING_LOW_LINE) },
    { key: 'strike', label: 'Strikethrough', transform: (t) => decorate(t, COMBINING_STRIKE) },
    { key: 'squiggle', label: 'Squiggle', transform: (t) => decorate(t, COMBINING_TILDE) }
  ];

  function fallbackCopyTextToClipboard(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    try {
      return document.execCommand('copy');
    } catch (err) {
      return false;
    } finally {
      document.body.removeChild(textarea);
    }
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext && !(window.Shopify && window.Shopify.designMode)) {
      return navigator.clipboard.writeText(text).then(
        () => true,
        () => fallbackCopyTextToClipboard(text)
      );
    }
    return Promise.resolve(fallbackCopyTextToClipboard(text));
  }

  class LunicodeGenerator extends HTMLElement {
    constructor() {
      super();
      this.styles = styles;
      this.input = null;
      this.output = null;
      this.status = null;
      this.statusTimer = null;
    }

    connectedCallback() {
      this.input = this.querySelector('[data-lunicode-input]');
      this.output = this.querySelector('[data-lunicode-output]');
      this.status = this.querySelector('[data-lunicode-status]');

      if (!this.input || !this.output) {
        return;
      }

      const hasServerCards = this.output.querySelector('[data-lunicode-card]') !== null;
      if (!hasServerCards) {
        this.renderCards(this.styles);
      }
      this.update();

      this.input.addEventListener('input', () => this.update());
      this.output.addEventListener('click', (e) => this.handleCopy(e));
    }

    renderCards(stylesToRender) {
      const fragment = document.createDocumentFragment();
      stylesToRender.forEach((style) => {
        const li = document.createElement('li');
        li.className = 'lunicode__card';

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'lunicode__card-button focus-inset';
        button.dataset.lunicodeCard = '';
        button.dataset.styleKey = style.key;
        button.setAttribute('aria-label', `Copy ${style.label} text`);

        const labelEl = document.createElement('span');
        labelEl.className = 'lunicode__card-label';
        labelEl.textContent = style.label;

        const previewEl = document.createElement('span');
        previewEl.className = 'lunicode__card-preview';
        previewEl.dataset.lunicodePreview = '';

        const hint = document.createElement('span');
        hint.className = 'lunicode__card-hint';
        hint.setAttribute('aria-hidden', 'true');
        hint.textContent = 'Tap to copy';

        button.appendChild(labelEl);
        button.appendChild(previewEl);
        button.appendChild(hint);
        li.appendChild(button);
        fragment.appendChild(li);
      });
      this.output.innerHTML = '';
      this.output.appendChild(fragment);
    }

    update() {
      const value = this.input.value || '';
      const cards = this.output.querySelectorAll('[data-lunicode-card]');
      cards.forEach((card) => {
        const key = card.dataset.styleKey;
        const style = this.styles.find((s) => s.key === key);
        if (!style) return;
        const preview = card.querySelector('[data-lunicode-preview]');
        try {
          preview.textContent = style.transform(value);
        } catch (err) {
          preview.textContent = value;
        }
      });
    }

    handleCopy(event) {
      const card = event.target.closest('[data-lunicode-card]');
      if (!card) return;
      const preview = card.querySelector('[data-lunicode-preview]');
      const text = preview ? preview.textContent : '';
      if (!text) {
        this.announce('Nothing to copy yet — type some text first.');
        return;
      }
      copyText(text).then((success) => {
        if (success) {
          card.classList.add('is-copied');
          this.announce('Copied to clipboard.');
          setTimeout(() => card.classList.remove('is-copied'), 1200);
        } else {
          card.classList.add('is-copy-failed');
          this.announce('Could not copy automatically. Select and copy manually.');
          setTimeout(() => card.classList.remove('is-copy-failed'), 1500);
        }
      });
    }

    announce(message) {
      if (!this.status) return;
      this.status.textContent = message;
      if (this.statusTimer) clearTimeout(this.statusTimer);
      this.statusTimer = setTimeout(() => {
        this.status.textContent = '';
      }, 2000);
    }
  }

  if (!customElements.get('lunicode-generator')) {
    customElements.define('lunicode-generator', LunicodeGenerator);
  }
})();
